// material
import { styled } from '@material-ui/core/styles';
// components
import Page from '../../components/Page';
import 
  Ledger
 from '../../components/_external-pages/approver/Ledger.js';
import DashboardNavbar from 'layouts/dashboard/DashboardNavbar';
import DashboardSidebar from 'layouts/dashboard/DashboardSidebar';


// ----------------------------------------------------------------------

const RootStyle = styled(Page)({
  height: '100%'
});

// ----------------------------------------------------------------------

export default function LedgerPage() {
  return (
    <RootStyle title="Admin" id="move_top">
      <Ledger />  
      <DashboardNavbar />
      <DashboardSidebar />
    </RootStyle>
  );
}
